import React, { useContext } from "react";
import Card from "../UI/Card";
import Item from "./Item/Item";
import useHttp from "../../hooks/use-http";
import Button from "../UI/Button";
import AppContext from "../../store/app-context";

import styles from "./ItemList.module.css";

const ItemList = (props) => {
  const { isLoading, error, sendRequest: getProductDetails } = useHttp();

  const appCtx = useContext(AppContext);

  let label_items = 'Items';
  let label_removeAllItems = 'Remove all items';
  let label_price = 'List Price';

  if(appCtx && appCtx.bioradResources){
    label_items = appCtx.bioradResources.Cart_Items_Header ? appCtx.bioradResources.Cart_Items_Header : 'Items';
    label_removeAllItems = appCtx.bioradResources.Remove_All_Items ? appCtx.bioradResources.Remove_All_Items : 'Remove all items';
    label_price = appCtx.bioradResources.List_Price ? appCtx.bioradResources.List_Price : 'List Price';
  }

  if (props.quote.isQuotedPrice) {
    label_price = appCtx && appCtx.bioradResources && appCtx.bioradResources.Quoted_Price ? appCtx.bioradResources.Quoted_Price : 'Quoted Price';
  } else if (props.quote.isAccountPrice) {
    label_price = appCtx && appCtx.bioradResources && appCtx.bioradResources.Account_Price ? appCtx.bioradResources.Account_Price : 'Your Price';
  }

  const itemList = props.quote.quoteLineEntityList.map((item) => (
    <Item
      id={item.quoteLineKey}
      key={item.quoteLineKey}
      sku={item.skuNumber}
      title={item.skuTitle}
      description={item.skuDescription}
      unitPrice={item.formattedUnitPrice}
      extendedPrice={item.formattedExtendedPrice}
      quantity={item.quantity}
      errorMessage={item.invalidSKUMessageTransient}
      imageSrc={item.skuImageUrl}
      isEditable={props.isEditable}
      onItemChange={props.onItemChange}
      deleteItemHandler={props.deleteItemHandler}
      webRef={item.webReference}
      skuUrl={item.skuUrl}
      skuType={item.skuType}
      instrument={item.instrument}
      rebrand={props?.rebrand}
    />
  )); //(<li key={item.itemKey}>{item.name}</li>));

  const formSubmitHandler = (event) => {
    event.preventDefault();
    props.itemFormSubmitHandler(props.itemChanges, props.quote.webReference);
  }

  const deleteAllItemHandler = (event) => {
    event.preventDefault();
    props.deleteItemHandler("all", props.quote.webReference)
  }

  return (
    <section className={`${props?.rebrand ? styles.quoteItemListBlock : ""} ${styles.items}`}>
        {props?.rebrand ? 
          <div>
            {props.isEditable && (
              <span className={styles.removeAll}>
                <Button onClick={deleteAllItemHandler}>{label_removeAllItems}</Button>
              </span>
            )}
            <div className={styles.newListheaders}>
              <div className={styles.listheaders__items}>
                <span className={styles.name}>
                  {label_items}
                </span>
              </div>
              <span className={styles.price}>
                {label_price}
              </span>
            </div>
          </div>
        :<div className={styles.listheaders}>
          <div className={styles.listheaders__items}>
            <span className={styles.name}>
              <strong>{label_items}</strong>
            </span>
            {props.isEditable && (
              <span className={styles.removeItems}>
                <Button onClick={deleteAllItemHandler}>{label_removeAllItems}</Button>
              </span>
            )}
          </div>
          <span className={styles.price}>
            <strong>{label_price}</strong>
          </span>
        </div>
      }
      <Card>
      {props.isEditable && (
        <form method="post" className={styles.form} onSubmit={formSubmitHandler}>
          <input type="hidden" name="webRef" value={props.quote.webReference} />
          <ul className={props?.rebrand ? styles.newItemList:''}>{itemList}</ul>
        </form>
      )}
      {!props.isEditable && (
        <ul className={props?.rebrand ? styles.newItemList:''}>{itemList}</ul>
      )}
      </Card>
      {props?.rebrand && props.isEditable && (
        <div className={styles.seperator}>
          <span className={styles.removeAll}>
            <Button onClick={deleteAllItemHandler}>{label_removeAllItems}</Button>
          </span>
        </div>
      )}
    </section>
  );
};

export default ItemList;

export const action = async ({ request, params }) => {
  const form = await request.formData();
  let itemIds = '';
  let qtys = '';
  let webReference = ''
  for (const [key, value] of [...form.entries()]){
    if(key === 'webRef'){
      webReference = value;
      continue;
    }
    itemIds += key + ',';
    qtys += value + ',';
  }

  const url = "/quoteservices/rfqs/items/" + webReference + "?itemIds=" + itemIds + "&qtys=" + qtys;

  //console.log(url+ ' :: ' + itemIds + ' :: ' + qtys);
  window.location.reload(true);
  return {a: "something"};//redirect('/'+webReference);
}